import { all, call, cancelled, fork, put, select, take, takeEvery } from 'redux-saga/effects';
import {
  SET_PARAMETROS_EMBEDDED_BI_INIT,
  SET_ARQUITETURA_PBI_ATIVA_INIT,
  CRIAR_WORKSPACE_INIT,
  ATUALIZAR_WORKSPACE_INIT,
  CRIAR_NOVA_VERSAO_WORKSPACE_INIT,
  POWERBI_WORKSPACE_SUCCESS,
  POWERBI_WORKSPACE_ERROR
} from '../../actionTypes';
import {
  setParametrosEmbeddedBiSuccess,
  errorParametrosEmbeddedBiMsg,
  setArquiteturaPbiAtivaSuccess,
  errorArquiteturaPbiAtivaMsg
} from './actions';
import { getEmpresaInit, getPaineisEmpresaAtualInit, getPaineisUsuarioInit } from 'src/redux/actions';
import {
  atualizaParametrosEmbedded,
  atualizaArquiteturaPbiAtiva
} from 'src/integracoes/servicos/mongo-atlas/funcoes/empresas';
import { IEmpresaParametrosEmbeddedBi } from 'src/integracoes/servicos/mongo-atlas/modelos/IEmpresa';
import { SagaIterator, EventChannel } from 'redux-saga';
import { criarPowerBiWorkspaceChannel, atualizarPowerBiWorkspaceChannel, criarNovaVersaoWorkspaceChannel } from 'src/integracoes/servicos/powerbi/funcoes/powerbi';

// Atualizar parametros embedded -------------------------
const fetchAtualizaParametrosEmbedded = async (
  empId: string,
  parametrosEmbeddedBi: IEmpresaParametrosEmbeddedBi
) => {
  const { status, mensagem } = await atualizaParametrosEmbedded(empId, parametrosEmbeddedBi);
  if (status) {
    return { isUpdated: true, msg: mensagem, chave: parametrosEmbeddedBi.chave };
  } else {
    return { isUpdated: false, msg: mensagem, chave: parametrosEmbeddedBi.chave };
  }
};

function* parceAtualizaParametrosEmbedded({ payload }: { payload: any; type: any }) {
  const { empId, parametrosEmbeddedBi } = payload;
  try {
    const { isUpdated, msg, chave } = yield call(
      fetchAtualizaParametrosEmbedded,
      empId,
      parametrosEmbeddedBi
    );
    if (isUpdated) {
      yield put(setParametrosEmbeddedBiSuccess({ msg, chave }));
      yield put(getEmpresaInit({ empId }));
      yield put(getPaineisEmpresaAtualInit(empId));
    } else {
      yield put(errorParametrosEmbeddedBiMsg({ msg }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorParametrosEmbeddedBiMsg({ msg: mensagem }));
  }
}

export function* watchAtualizaParametrosEmbedded() {
  yield takeEvery(SET_PARAMETROS_EMBEDDED_BI_INIT, parceAtualizaParametrosEmbedded);
}

// Atualizar arquitetura PBI ativa -------------------------
const fetchAtualizaArquiteturaPbiAtiva = async (empId: string, chave: string) => {
  const { status, mensagem } = await atualizaArquiteturaPbiAtiva(empId, chave);
  if (status) {
    return { isUpdated: true, msg: mensagem };
  } else {
    return { isUpdated: false, msg: mensagem };
  }
};

function* parceAtualizaArquiteturaPbiAtiva({ payload }: { payload: any; type: any }) {
  const { empId, chave } = payload;
  try {
    const { isUpdated, msg } = yield call(fetchAtualizaArquiteturaPbiAtiva, empId, chave);
    if (isUpdated) {
      yield put(setArquiteturaPbiAtivaSuccess({ msg }));
      yield put(getEmpresaInit({ empId }));
      yield put(getPaineisEmpresaAtualInit(empId));
    } else {
      yield put(errorArquiteturaPbiAtivaMsg({ msg }));
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put(errorArquiteturaPbiAtivaMsg({ msg: mensagem }));
  }
}

export function* watchAtualizaArquiteturaPbiAtiva() {
  yield takeEvery(SET_ARQUITETURA_PBI_ATIVA_INIT as any, parceAtualizaArquiteturaPbiAtiva);
}

function* recarregarPaineis(empId: string): SagaIterator {
  yield put(getPaineisEmpresaAtualInit(empId));
  const user: any = yield select((state: any) => state.account.user);
  if (user?.id) {
    yield put(getPaineisUsuarioInit(user.id));
  }
}

// Criar workspace PowerBI -------------------------
function* provisionarWorkspaceSaga(action: any): SagaIterator {
  const { empId, versaoModelo } = action.payload;
  const channel: EventChannel<any> = yield call(criarPowerBiWorkspaceChannel, empId, versaoModelo);
  try {
    while (true) {
      const sseAction: any = yield take(channel);
      yield put(sseAction);

      if (sseAction.type === POWERBI_WORKSPACE_SUCCESS) {
        yield put(getEmpresaInit({ empId }));
        yield call(recarregarPaineis, empId);
        channel.close();
        break;
      }
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put({ type: POWERBI_WORKSPACE_ERROR, payload: mensagem });
  } finally {
    if (yield cancelled()) {
      channel.close();
    }
  }
}

export function* watchCriarWorkSpaceSse() {
  yield takeEvery(CRIAR_WORKSPACE_INIT, provisionarWorkspaceSaga);
}

// Atualizar workspace PowerBI -------------------------
function* atualizarWorkspaceSaga(action: any): SagaIterator {
  const { empId, versaoModelo } = action.payload;
  const channel: EventChannel<any> = yield call(atualizarPowerBiWorkspaceChannel, empId, versaoModelo);
  try {
    while (true) {
      const sseAction: any = yield take(channel);
      yield put(sseAction);

      if (sseAction.type === POWERBI_WORKSPACE_SUCCESS) {
        yield put(getEmpresaInit({ empId }));
        yield call(recarregarPaineis, empId);
        channel.close();
        break;
      }
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put({ type: POWERBI_WORKSPACE_ERROR, payload: mensagem });
  } finally {
    if (yield cancelled()) {
      channel.close();
    }
  }
}

export function* watchAtualizarWorkSpaceSse() {
  yield takeEvery(ATUALIZAR_WORKSPACE_INIT, atualizarWorkspaceSaga);
}

// Criar nova versão PowerBI -------------------------
function* criarNovaVersaoWorkspaceSaga(action: any): SagaIterator {
  const { workspaceId, datasetId, reportIdGeral, novaVersao } = action.payload;
  const channel: EventChannel<any> = yield call(criarNovaVersaoWorkspaceChannel, workspaceId, datasetId, reportIdGeral, novaVersao);
  try {
    while (true) {
      const sseAction: any = yield take(channel);
      yield put(sseAction);

      if (sseAction.type === POWERBI_WORKSPACE_SUCCESS) {
        channel.close();
        break;
      }
    }
  } catch (error: any) {
    const mensagem = error.mensagem ? `${error.mensagem}` : `${error.message}`;
    yield put({ type: POWERBI_WORKSPACE_ERROR, payload: mensagem });
  } finally {
    if (yield cancelled()) {
      channel.close();
    }
  }
}

export function* watchCriarNovaVersaoWorkspaceSse() {
  yield takeEvery(CRIAR_NOVA_VERSAO_WORKSPACE_INIT, criarNovaVersaoWorkspaceSaga);
}

// WATCHS ------------------------------------------------
export default function* rootSaga() {
  yield all([
    fork(watchAtualizaParametrosEmbedded),
    fork(watchAtualizaArquiteturaPbiAtiva),
    fork(watchCriarWorkSpaceSse),
    fork(watchAtualizarWorkSpaceSse),
    fork(watchCriarNovaVersaoWorkspaceSse)
  ]);
}
